module.exports = __webpack_public_path__ + "img/safe_08.33eede3d.png";